import React from 'react'
import { Container, Box, Flex } from 'theme-ui'
import { FooterLogo } from './Footer.Logo'
import { FooterMenu } from './Footer.Menu'
import { FooterSocial } from './Footer.Social'

const styles = {
  wrapper: {
    position: `relative`,
    bg: `footerBg`,
    mt: [5, 6]
  }
}

const scriptTags = `
    <script
      id="aioa-adawidget" 
      src="https://www.skynettechnologies.com/accessibility/js/all-in-one-accessibility-js-widget-minify.js?colorcode=#420083&token=ADAAIOA-3E1A69A80699EDD5F8A2689602C17BED&position=bottom_right"
      defer
    >
    </script>
  `;

export const Footer = () => (
  <Box sx={styles.wrapper}>
    <Container variant='compact' sx={styles.container}>
      <Flex variant='layout.footer'>
        <Box>
          <FooterLogo />
        </Box>
        <FooterMenu />
        <Box>
          <FooterSocial />
        </Box>
      </Flex>
    </Container>

    {/* Render the script tags with dangerouslySetInnerHTML */}
    <div dangerouslySetInnerHTML={{ __html: scriptTags }} />
  </Box>
)
